import { To } from 'react-router';

export interface IAppLogo {
  to?: To;
}

export enum APP_LOGO {
  ALT = 'alt',
  DEFAULT = 'default',
}
